import { render, staticRenderFns } from "./TopStat.vue?vue&type=template&id=3d417538&scoped=true&"
import script from "./TopStat.vue?vue&type=script&lang=js&"
export * from "./TopStat.vue?vue&type=script&lang=js&"
import style0 from "./TopStat.vue?vue&type=style&index=0&id=3d417538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d417538",
  null
  
)

export default component.exports